import { render, staticRenderFns } from "./SpielerCheckController.vue?vue&type=template&id=a7148aa4&scoped=true&"
import script from "./SpielerCheckController.vue?vue&type=script&lang=js&"
export * from "./SpielerCheckController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7148aa4",
  null
  
)

export default component.exports